import { render, staticRenderFns } from "./DisplayCategory.vue?vue&type=template&id=68876788&scoped=true&"
import script from "./DisplayCategory.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategory.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayCategory.vue?vue&type=style&index=0&id=68876788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68876788",
  null
  
)

export default component.exports